import {Pipe, PipeTransform} from '@angular/core';

const transform = (value: any): string => {
  if (typeof value === 'string') {
    return transformString(value);
  } else if (Array.isArray(value)) {
    return transformArray(value);
  } else if (value instanceof Set) {
    return transformArray([...value])
  }

  return '';
}

const transformString = (value: string): string => {
  if (value == undefined) return ''
  
  let newValue = value.toLocaleLowerCase()
  while (newValue.indexOf('_') != -1) {
    newValue = newValue.replace('_', ' ')
  }
  
  let firstCharacter = newValue.charAt(0).toLocaleUpperCase()
  newValue = newValue.substring(1, newValue.length)
  
  return firstCharacter + newValue
}

const transformArray = (value: any[]): string => {
  return value
    .map(item => transform(item))
    .filter(item => item !== '')
    .join(', ');
}

@Pipe({
  name: 'toCapitalizedText',
  standalone: true
})
export class ToCapitalizedTextPipe implements PipeTransform {
  constructor() {
  }
  
  public transform(value?: any): string {
    return transform(value);
  }
}